import { Progress } from "antd"
import './index.scss'


interface competitionItem {
    name: string
    value: number
    percent: number
}

interface industryKeyItem {
    content: string
}

const competitionData: competitionItem[] = [
    {
        name: '宁德时代',
        value: 37.6,
        percent: 28,
    },
    {
        name: '比亚迪弗迪',
        value: 16.1,
        percent: 45,
    },
    {
        name: 'LG新能源',
        value: 12.4,
        percent: 15,
    },
    {
        name: '松下',
        value: 8.2,
        percent: 10,
    },
    {
        name: '三星SDI',
        value: 6.5,
        percent: 10,
    },
    {
        name: '其他',
        value: 4.8,
        percent: 10,
    }
]

const industryKeyList: industryKeyItem[] = [
    {
        content: '电池技术迭代加速，高能量密度、高安全性的电池成为主流',
    },
]

export default function IndustryAnalysis() {
    return (
        <div className="industry-analysis">
            <div className="industry-analysis__body">
                <div className="industry-analysis__title">市场规模预测</div>
                <div className="industry-analysis__market-content">
                    <div className="industry-analysis__market-item">
                        <div className="industry-analysis__content-item-title">当前市场规模</div>
                        <div className="industry-analysis__market-item-value">0.8<i className="unit text-10">万亿</i></div>
                    </div>
                    <div className="industry-analysis__market-item">
                        <div className="industry-analysis__content-item-title">2025年预测</div>
                        <div className="industry-analysis__market-item-value">1.2<i className="unit text-10">万亿</i></div>
                        <div className="industry-analysis__content-item-percent green">CAGR +41%</div>
                    </div>
                    <div className="industry-analysis__market-item">
                        <div className="industry-analysis__content-item-title">2027年预测</div>
                        <div className="industry-analysis__market-item-value">1.9<i className="unit text-10">万亿</i></div>
                        <div className="industry-analysis__content-item-percent green">CAGR +24%</div>
                    </div>
                </div>
                <div className="industry-analysis__title">竞争格局（全球市占率）</div>
                <div className="industry-analysis__content">
                    {competitionData.map((item,index) => (
                        <div key={item.name} className="industry-analysis-item-row competition-item">
                            <div className="industry-analysis-item-row-name">{item.name}</div>
                            <div className="industry-analysis__progress">
                                <Progress
                                    percent={item.value}
                                    showInfo={false}
                                    size={['100%', 5]}
                                    railColor='var(--bg-card-alt)'
                                    strokeColor={index === 0 ? 'var(--accent)' : 'var(--text-3)'}
                                />
                            </div>
                            <div className='industry-analysis-item-value'>{item.value}%</div>
                            <div className={`${item.percent > 0 ? 'green' : 'red'} industry-analysis-item-percent text-10`}>{item.percent > 0 ? '+' + item.percent : item.percent}%</div>
                        </div>
                    ))}
                </div>
                <div className="industry-analysis__title">行业关键趋势</div>
                <div className="industry-analysis__content">
                    {industryKeyList.map((item,index) => (
                        <div key={index} className="industry-analysis-item-row industry-analysis-key-item">
                            <span className="industry-analysis-key-item-dot"></span>
                            {item.content}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}